import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { EntitiesTab } from "components/Client/Entities/EntitiesTab";
import { OverviewTab } from "components/Client/Overview/OverviewTab";
import { ReportingTab } from "components/Client/Reporting/ReportingTab";
import { TasksTab } from "components/Client/Tasks/TasksTab";
import { WorkspaceTab } from "components/Client/Workspace/WorkspaceTab";
import { Routes } from "constants/routes";

export const ClientRouter: React.FC = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path={Routes.clientDashboard} component={OverviewTab} />
      <Route exact path={Routes.clientOverview} component={OverviewTab} />
      <Route path={Routes.clientWorkspace} component={WorkspaceTab} />
      <Route path={Routes.clientTasks} component={TasksTab} />
      <Route path={Routes.clientEntities} component={EntitiesTab} />
      <Route path={Routes.clientReporting} component={ReportingTab} />
      <Route path={Routes.client} component={OverviewTab} />
      <Redirect to={Routes.clients} />
    </Switch>
  );
};
